import { PropsWithChildren } from 'react';
import { cn } from '@sib/ui';

interface DetailWrapperProps {
  label: string;
  className?: string;
}

export const TicketDetailWrapper = ({
  label,
  className,
  children,
}: PropsWithChildren<DetailWrapperProps>) => (
  <div className={cn('flex flex-col', className)}>
    <p className="text-muted-foreground text-[10px] leading-4">{label}</p>
    <div className="text-primary text-sm font-normal">{children}</div>
  </div>
);
